import { logisticsAsset, logisticsSafety, manufacturingSteel } from "@pages/Enterprise/Solution/components/Banner/BannerImages";
import productImg from "../main/product/productImg";
import productPurchase from "../main/product/productPurchase";

export default {
  desc: '여러분은 넷플릭스에서 다음에 볼 영화를 어떻게 척척 추천하는지, 또는 시리(Siri) 같은 음성 비서가 어떻게 우리 말을 척척 알아듣고 똑똑하게 답하는지 궁금해 본 적이 있나요? 이 모든 비밀은 바로 Machine Learning (머신러닝) 즉, 인공지능(AI)의 한 갈래에 숨어 있습니다. 이 글에서는 ‘Machine Learning이이 무엇인지, 어떻게 작동하는지, 그리고 일상생활에 가져오는 놀라운 활용 사례를 알아보겠습니다.',
  keywords: ' Machine Learning, 머신러닝, 기계 학습, AI, 인공지능',
  ogSite: 'Machine Learning이란 무엇일까?',
  title: 'Machine Learning이란 무엇일까?',
  ogUrl: 'https://orbro.io/blog/machine-learning',
  ogImg: 'https://lh3.googleusercontent.com/fife/ALs6j_Hv4dRRsX1GxqCI9Wfe_A3CEoCop3PH-5yw5f7EdXKdlcJQuX2YbcxReqgi5iz9DMYI1inOOccX6m58fJBnO86D_VUD3gC-L3CMij9sr3H3zflKVyPzce6D9UbO0p8P59IFN5AX-HUlW25hDDwueabGKgzY9oKOx5VllCjzLNZ4uTtQncCHvziRUmBJzqmpq0zTijJhIfAXwS1QP6-D6e8szlxyTu_eMOIxm99EwNssKansfBAjux8EOskigqGxwSgnJ_d8YyMy9snswBB-pLvjt7bZgnq6QZJtn5hTVstyeX5obTtLZtE-VIRclBKmTO-bNTnl2pInUlZZg63kBbkpq33S1lm4WZOSdQka_B-7bsHWqZmDJasA--Hxu-4tK50d1hKognKJsIzsTKM0J3kh_2TU6C2GMq90yesxliPC9l8DkzbuxuXM-cOliKy7ZxDrEXGm18mr-sVIhvbQUIdvFRSgdm-6a5YIFh99PyUJP6b__BvaQTYIopWsMCUmlJw6JvvvzK6OlpKHeC38z71Sm-3XOwzEF0hg0-nlqO1Lj69QdvO6RE3E4pl6qyVJpycoC7N0UeA0Z4mCYy-aq-TQgWLtmKFR_2mUwgUHixwsSHKKHPzpXbGiiBBNNnbalco4GUmC7UHVn08a3_mO3yvLYNyHW2SG5maSUf84DvJcaX8wMcImUTc-hn221WrcOv0UEoz_Ww0d-y5a7y35thgIXbSxAgajQcXfsE04N8nRh33-ZN87YGkCjjuhwpisuUOgavo7dDTDzT8uqnDh22CWCtaEE1YVXmSlgpKBBBdo0PO1B8i_wXtXK8JrgnKksdNRl39qW3bSb0JLhcfPQxFMIbpxaKz9xkNn4Bg6MNf1trbdh_4F_t1vRj401adxVZpE8jymniEDPEw0RvcrwUoskVgDFGjTJtYxqjcuu-8wQ8865QaDPhKVsziv6YuXgCMVwCyGHedmVEphu6laGAsHOWLYZtOZQ4-XGFaj0Z8EILNCftwwoGg0UEEgTxnk2bF2OCaGAdshL2CLg6vIaQoub-7_gD0ryJ5zDwwInVhlGj7Ts-JCEVUVK7FttYls-yQuy4kcVrl2fH88MCImKWfHbC-dsGTGjg79Qzb7qUVpMYQoQ_MEyCbj-W9I8u8v1NhXjilwl0uJKRtXVa_N263-8po600zu9Hna7jkgfvleXER_z7TkyJCOJGtW4g3jVp2cdSraIfpWMhNGGum3mGnN6ko8sfJlA7AUVnola5O-cXQyOJIrEjq8ZBOhDZINlvcPGLlFj_HmIQWAg93MYuQv-PK3O2VX6RZjhCiullM5Gi8NvXJ2zRpbCyqoidvvsE9cvdhjp7YnYrBYy9NUwV5T7yN3M-84N7nZr4YjArYHQc3I0B33OR0HGZIch1_PRP2wFeFoRdihVzaAyCshLN97VejtcIC3KG6aDsQyncc9W5O6je3uqzlIiOZ7fVT1uvquJAuxANlLJe0LsFeSg9nG8wF9lD76Kp7-CTRdkU5Vb-q4L353gmcQZcmF1FrRr14ijuBku66s2M3SfL9eFwA-wGLFoHD6UetLKvwWzBe3Y9rFGdBXq0ZX0-KT5IDsV9ifKU3qtCUMrSHqiRF5zqaHoYghcKVIvvWl=w1418-h1412?auditContext=forDisplay',
  ogType: 'website',
  date: '2025-07-09',
  tag1: '#MachineLearning',
  tag2: '#머신러닝',
  tag3: '#기계 학습',
  tag4: '#AI #인공지능',
  text: [
    {
      head: '',
      subHead: '',
      desc: '여러분은 넷플릭스에서 다음에 볼 영화를 어떻게 척척 추천하는지, 또는 시리(Siri) 같은 음성 비서가 어떻게 우리 말을 척척 알아듣고 똑똑하게 답하는지 궁금해 본 적이 있나요? 이 모든 비밀은 바로 Machine Learning (머신러닝) 즉, 인공지능(AI)의 한 갈래에 숨어 있습니다. 이 글에서는 ‘Machine Learning이이 무엇인지, 어떻게 작동하는지, 그리고 일상생활에 가져오는 놀라운 활용 사례를 알아보겠습니다.',
      dot: ''
    },
    {
      head: '1. Machine Learning이란?',
      subHead: '',
      desc: 'Machine Learning (머신러닝)은 “컴퓨터가 스스로 학습한다”는 개념을 담고 있습니다. 머신러닝은 인공지능(AI)의 한 분야로, 컴퓨터가 명시적인 프로그래밍 없이 데이터로부터 “학습”할 수 있도록 하는 알고리즘 개발에 초점을 맞춥니다. 세부적인 명령어를 일일이 작성하는 대신, 우리는 컴퓨터에 대량의 데이터를 제공하고, 이를 통해 스스로 규칙과 패턴을 찾아내 예측하거나 결정을 내리도록 합니다.\n\n쉽게 말해, Machine Learning은 컴퓨터가 인간처럼 경험을 통해 학습하고 시간이 지남에 따라 성능을 개선하도록 돕습니다. 이 기술은 의료, 금융, 엔터테인먼트, 교통 등 다양한 분야에서 널리 사용되고 있습니다.\n\n예를 들어, 여러분의 스마트폰이 스스로 사진 속 친구 얼굴을 인식해 태그를 달아주는 과정도 Machine Learning 덕분입니다.',
      dot: ''
    },
    {
      head: '2. Machine Learning은 어떻게 작동할까?',
      subHead: '',
      desc: 'Machine Learning 모델이 ‘똑똑해지는’ 과정은 크게 네 단계로 이루어집니다.\n\n• 데이터 수집: 컴퓨터를 “가르치기” 위해 크고 다양한 데이터 세트가 필요합니다. 이 데이터는 이미지, 텍스트, 숫자 등일 수 있습니다.\n\n• 모델 학습: 머신러닝 알고리즘을 사용해 데이터를 분석하고 숨겨진 패턴과 규칙을 찾아냅니다.\n\n• 테스트 및 조정: 새로운 데이터로 모델의 성능을 평가한 뒤 정확도를 높이기 위해 조정합니다.\n\n• 배포 및 예측: 학습된 모델을 실제 데이터에 적용해 예측이나 결정을 내립니다.\n\n이 과정을 반복하며 머신러닝 모델은 점점 더 정교해지고, 우리 삶에 더욱 밀착된 서비스를 제공합니다.\n\n예시: 날씨 예보 앱은 머신러닝을 활용해 과거 기상 데이터를 분석하여 내일의 날씨를 높은 정확도로 예측합니다.',
      dot: ''
    },
    {
      head: '3. Machine Learning의 주요 유형',
      subHead: '',
      desc: 'Machine Learning은 크게 세 가지 유형으로 나뉘며, 각 유형은 고유한 접근 방식과 활용 사례를 살펴볼까요?',
      dot: ''
    },
    {
      head: '',
      subHead: '지도 학습 (Supervised Learning)',
      desc: '특징: 데이터에 이미 정답(레이블)이 포함된 상태로 모델을 학습시킵니다.\n예시: 스팸 메일 분류, 음성 인식, 주택 가격 예측\n작동 원리: 입력 데이터와 함께 정답을 알려주면, 컴퓨터가 입력하여 정답 관계를 찾아냅니다.',
      dot: ''
    },
    {
      head: '',
      subHead: '비지도 학습 (Unsupervised Learning)',
      desc: '특징: 레이블이 없는 데이터에서 스스로 구조와 패턴을 찾아냅니다.\n예시: 고객 세분화, 이상치 탐지, 추천 시스템의 초기 데이터 분석\n작동 원리: 컴퓨터가 데이터 간의 유사성을 분석해 그룹화하거나 특징을 추출합니다.',
      dot: ''
    },
    {
      head: '',
      subHead: '강화 학습 (Reinforcement Learning)',
      desc: '특징: 시행착오(trial-and-error)를 통해 최적 행동을 학습, 보상(reward)·벌점(penalty)으로 학습 강화시킵니다.\n예시: 자율주행 자동차, 게임 AI, 로봇 제어\n작동 원리: 행동마다 보상을 주고, 최대 보상을 얻는 방향으로 학습합니다.',
      dot: ''
    },
    {
      head: '4. Machine Learning의 실제 활용 사례',
      subHead: '',
      desc: 'Machine Learning은 이론에 그치지 않고 다양한 분야에서 실질적인 가치를 창출하고 있습니다.\n\n• 의료 (AI 진단)\nX-ray·MRI 이미지에서 암·심장 질환을 조기 진단해, 전문의보다 빠르고 정확하게 병변을 찾아냅니다.\n \n• 금융 (부정거래 탐지)\n수많은 거래 패턴을 실시간 분석해, 의심스러운 거래를 즉시 차단하고 고객의 자산을 지켜줍니다.\n\n• 교통 (자율주행)\n차선, 보행자, 장애물을 인식해 사람 대신 안전하게 운전 경로를 결정합니다.\n\n• 전자상거래 (상품 추천)\n여러분의 검색·구매 이력을 바탕으로 ‘다음에 이 상품은 어떠세요?’라는 맞춤형 추천을 제공합니다.\n\n• 엔터테인먼트 (콘텐츠 큐레이션)\n시청 기록을 학습해 관심 있을 만한 영화·음악·영상을 정확하게 골라줍니다.',
      dot: ''
    },
    {
      head: '5. Machine Learning의 이점',
      subHead: '',
      desc: 'Machine Learning은 기업과 사용자에게 뛰어난 이점을 제공합니다.\n\n• 높은 자동화 수준: 수작업을 줄이고 시간을 절약합니다.\n\n• 데이터 기반 의사결정 강화: 데이터 기반의 스마트한 의사결정을 가능하게 합니다.\n\n• 개인화 서비스 제공: 사용자별 맞춤형 경험을 제공합니다.\n\n• 운영 비용 절감: 프로세스를 최적화하여 낭비를 줄입니다.\n\n• 조기 문제 탐지 및 예방: 기계 오류나 사기를 빠르게 탐지합니다.\n\n예시: 물류 회사는 머신러닝으로 운송 수요를 예측해 경로를 최적화하여 연료 비용을 15% 절감했습니다.',
      dot: ''
    },
    {
      head: '6. 머신러닝의 도전 과제와 미래',
      subHead: '',
      desc: '머신러닝은 무한한 가능성을 열어주지만, 다음과 같은 몇 가지 해결해야 할 과제가 있습니다.\n\n• 데이터 품질: 정확하고 풍부한 데이터가 없으면 모델의 성능이 떨어집니다.\n\n• 보안 및 개인정보 보호: 개인 데이터가 오용될 가능성에 대한 우려가 큽니다.\n\n• 초기 투자 비용: 기술 도입과 전문 인력 확보에 상당한 비용이 필요합니다.\n\n그럼에도 불구하고, 머신러닝의 미래는 더욱 밝고 혁신적입니다.\n\n• 진화하는 AI 기술: 더 빠르고 정교한 학습 능력을 갖춘 모델이 등장할 것입니다.\n\n• 다양한 분야로의 확장: 의료, 교육, 농업 등 모든 산업에 깊이 스며들 것입니다.\n\n• 일상생활과의 융합: 개인화된 가상 비서나 완전 자율 주행 차량처럼 우리 삶을 더 편리하게 만들 것입니다.',
      dot: ''
    },
    {
      head: '7. 결론',
      subHead: '',
      desc: 'Machine Learning은 단순한 기술 트렌드가 아니라 우리가 생활하고, 일하고, 세상과 상호작용하는 방식을 바꾸는 혁명입니다. 날씨 예측, 영화 추천, 질병 조기 진단 등 Machine Learning은 수많은 실질적인 이점을 제공합니다. 이 기술에 대해 더 알아보고 싶으신가요? ORBRO와 함께 최신 기술의 세계를 계속 탐험해보세요!',
      dot: ''
    }
  ],

  link: {
    page: 'rtls',
    numb: '1',
    product: [
      {
        text: productPurchase.purchase.ble.bleStarterKit.title,
        title: productPurchase.purchase.ble.bleStarterKit.title,
        serial: productPurchase.purchase.ble.bleStarterKit.serial,
        desc: 'UWB 단말기를 작업자 또는 장비에 부착하여, 실시간으로 위치 추적을 돕는 제품입니다.',
        img: productImg.product.bleStarterKit.key1,
      },
      {},
    ],
    solution: [
      {
        img: logisticsAsset.thumb,
        data: 'logisticsAsset',
        link: '/enterprise/logistics/asset',
      },
      {
        img: logisticsSafety.thumb,
        data: 'logisticsSafety',
        link: '/enterprise/logistics/safety',
      },
      {
        img: manufacturingSteel.thumb,
        data: 'manufacturingSteel',
        link: '/enterprise/manufacturing/steel',
      },
    ],
  },
};
